/* eslint-disable import/prefer-default-export */
import { add, eachDayOfInterval, format, isAfter } from 'date-fns';
import { es } from 'date-fns/locale';
import dayjs from 'dayjs';

/** @param {{start: Date, end: Date, dateFormat: string}} */
export const getDaysInterval = ({ start, end, dateFormat }) => {
  const days = eachDayOfInterval({ start, end });

  return dateFormat ? days.map((day) => format(day, dateFormat, { locale: es })) : days;
};

/** @param {{start: string, end: string, dateFormat: string}} */
export const isInDateRange = (start, end, dateToCheck) => {
  const startDay = add(new Date(start), { days: -1 });
  const endDay = add(new Date(end), { days: 1 });

  return isAfter(new Date(dateToCheck), startDay) && isAfter(endDay, new Date(dateToCheck));
};

export const today = dayjs();
export const todayIso = today.format('YYYY-MM-DDTHH:mm:ss');
export const fromDate = today.subtract(28, 'day').startOf('day');
export const isoFromDate = fromDate.format('YYYY-MM-DDTHH:mm:ss');

export const parseDateFormat = (dateTime) => dayjs(dateTime).format('YYYY-MM-DD');
